var map = {
	"./floor_texture.webp": 428,
	"./floor_texture_2.webp": 8613,
	"./floor_texture_3.webp": 6746,
	"./floor_texture_4.webp": 6231,
	"./floor_texture_5.webp": 2532,
	"./wall_inside_texture.webp": 2031,
	"./wall_inside_texture_2.webp": 674,
	"./wall_outside_texture.webp": 4430
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17;